import React from 'react';
import {useTranslation} from 'react-i18next';
import {IconclassRef} from '../../../admin/artisticobjects/types/ArtisticObject';

interface DetailsIconclassListProps {
  iconclasses: IconclassRef[];
}

const DetailsIconclassList: React.FC<DetailsIconclassListProps> = ({ iconclasses }) => {
  const {t} = useTranslation();
  if (!iconclasses || iconclasses.length === 0) {
    return null;
  }

  const allKeywords = iconclasses
    .flatMap(iconclass => iconclass.keywords)
    .filter((keyword, index, self) => self.indexOf(keyword) === index)
    .sort();

  return (
    <>
      <div id="iconclass-card" className="bg-white shadow-sm p-6">
        <h3 className="text-lg font-semibold text-stone-900 mb-4">{t('details.sections.iconclasses')}</h3>
        <div className="space-y-2">
          {iconclasses.map((iconclass) => (
            <div key={iconclass.code} className="text-sm text-stone-700">
              <span className="font-semibold">{iconclass.code}</span>
              <span className="mx-1">-</span>
              <span>{iconclass.name}</span>
            </div>
          ))}
        </div>
      </div>

      {allKeywords.length > 0 && (
        <div id="keywords-card" className="bg-white shadow-sm p-6">
          <h3 className="text-lg font-semibold text-stone-900 mb-4">{t('details.sections.keywords')}</h3>
          <div className="text-sm text-stone-700">
            {allKeywords.join(' · ')}
          </div>
        </div>
      )}
    </>
  );
};

export default DetailsIconclassList;

